<template>
  <matrix
      allow-horizontal
      :has-data="routeHasData"
      fetching-message="All properties (0)"
  >
    <template #table-header>
      <t-column class="corner"></t-column>
      <template v-for="permittee in permissionsTablePermittees">
        <t-column is-heading :key="permittee.client_id" size="">
          <span v-tooltip="permittee.display">{{ permittee.display }}</span>
          <suffix class="c-row align-items-baseline">
            <button v-if="permittee.legacyConfigTooltip" class="tooltip-btn grey" v-tooltip="permittee.legacyConfigTooltip">
              <icon class="exclamation"></icon>
              <span class="sr-only">{{ permittee.legacyConfigTooltip }}</span>
            </button>

            <kebab-actions-menu>
              <li v-if="!permittee.isFirst">
                <button @click="moveLeft(permittee)" class="dropdown-item">Move to Left</button>
              </li>
              <li v-if="!permittee.isLast">
                <button @click="moveRight(permittee)" class="dropdown-item">Move to Right</button>
              </li>
              <li>
                <button @click="$emit('remove-permittee', permittee)" class="dropdown-item">Delete</button>
              </li>
            </kebab-actions-menu>
          </suffix>
        </t-column>
      </template>
      <template >
        <t-column class="empty_cell" v-for="index in remainingColumns" is-heading :key="`empty_header_${index}`" size="">&nbsp;</t-column>
      </template>
    </template>

    <template #table-body >
      <slot name="table-rows" :remaining-columns="remainingColumns" ></slot>
    </template>
  </matrix>
</template>

<script lang="ts">
import Vue from 'vue';
import selectedMixin from "../mixins/selectedMixin";
import permissionTablePermitteesMixin from '../mixins/permission-table-permittees-mixin';
import KebabActionsMenu from '~/components/kebab-actions-menu.vue';
import {BuilderArea} from "../enums/builder-area";
import ObjectModelPermissionPermittee from "~/models/objectModelPermissionPermittee";
import {StringHelper} from "~/helpers/stringHelper";
import remainingColumnMixin from "../mixins/remaining-column-mixin";

export default Vue.extend({
  mixins: [
    selectedMixin,
    permissionTablePermitteesMixin,
    remainingColumnMixin
  ],
  components: {
    KebabActionsMenu,
  },
  computed: {
    routeHasData() {
      switch (this.$route.name) {
        case BuilderArea.permissionsActions:
          return true; // Object Model always has default actions
        case BuilderArea.permissionsProperties:
          return this.selectedObjectModel.hasProperties || this.selectedObjectModel.hasSections;
        case BuilderArea.permissionsRelationships:
          return this.selectedObjectModel.hasRelations || this.selectedObjectModel.hasInverseRelations;
      }
    }
  },
  methods: {
    permitteeDisplayTooLong(permittee: ObjectModelPermissionPermittee): boolean {
      return permittee.display.length > 15;
    },
    shortenedPermitteeDisplay(permittee: ObjectModelPermissionPermittee): string {
      return StringHelper.limitString((permittee.display as string), 15, 'midpoint');
    },
    moveLeft(permittee: ObjectModelPermissionPermittee): void {
      permittee.moveLeft();
    },
    moveRight(permittee: ObjectModelPermissionPermittee): void {
      permittee.moveRight();
    },
  },
  mounted(){
    $('#panel-permissions').on('mouseenter', '.enable-all', function(){
      $(`*[id*=${$(this).data('hover')}]:visible`).closest('.column').addClass('hover');
    });
    $('#panel-permissions').on('mouseleave', '.enable-all', function(){
      $(`*[id*=${$(this).data('hover')}]:visible`).closest('.column').removeClass('hover');
    });
    
    $('#panel-permissions').on('mouseenter', '.has-actions .column', function(){
      let this_index = $(this).index();
      let group = $(this).closest('.c-row').find('.toggle-group').data('target');
      $(`${group} > .c-row > .column:nth-child(${this_index + 1})`).addClass('hover');
    });
    $('#panel-permissions').on('mouseleave', '.has-actions .column', function(){
      let this_index = $(this).index();
      let group = $(this).closest('.c-row').find('.toggle-group').data('target');
      $(`${group} > .c-row > .column:nth-child(${this_index + 1})`).removeClass('hover');
    });

    $('#panel-permissions').on('shown.bs.collapse', '.collapse', function () {
      $(this).prev().addClass('open');
    });
    $('#panel-permissions').on('hidden.bs.collapse', '.collapse', function () {
      $(this).prev().removeClass('open');
    });
  }
});
</script>